import { render } from "./RoleTypeComponent.vue?vue&type=template&id=52a22024&scoped=true"
import script from "./RoleTypeComponent.vue?vue&type=script&lang=js"
export * from "./RoleTypeComponent.vue?vue&type=script&lang=js"

import "./RoleTypeComponent.vue?vue&type=style&index=0&id=52a22024&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a22024"]])

export default __exports__